import { HttpMethod } from '@pool-league/shared-util-http';
import { GetOperation } from '../operation';

export const GET_LATEST_RESULTS: GetOperation<void> = {
  path: ['results'],
  method: HttpMethod.GET,
};
